<div class="contact-slider">
  <div *ngIf="candidateDetails?.length == 0 && !similartabshow" class="w-100 d-flex justify-content-center">
    <img src="../../assets/rolling-loader.gif" style="width: 50px;" alt="">
  </div>
  <div class="row mx-2 pl-3 justify-content-between" *ngIf="candidateDetails?.length > 0 && similartabshow">
    <p class="f-14 font-weight-600" >{{totalcount > 99 ? '99+': totalcount}} Similar Candidates Found </p>
    <p class="float-right text-webbtree-green pointer f-12 font-weight-600" (click)="redirecttolisting()">View All</p>
  </div>
  <div *ngIf="candidateDetails?.length > 0 && similartabshow">
    <div *ngFor="let data of candidateDetails; let i = index;">
      <div class="d-flex">
        <div class="d-flex">
          <!-- <div class="profilepic">
              <i class="fa-solid fa-user"></i>
          </div> -->
          <div class="mx-2 pl-3">
              <div class="circular-img mr-3 mb-3 text-capitalize" [ngClass]="{
                  'lavender-circle': i % 4 == 0,
                  'yellow-circle': i % 4 == 1,
                  'blue-circle': i % 4 == 2,
                  'teal-circle': i % 4 == 3
                }">{{transform(data?.full_name).charAt(0)}}</div>
          </div>
      </div>
      <div class="justify-content-between">
          <p class="f-14 font-weight-600 mb-1 d-grid" *ngIf="data?.full_name">
              <span class="text-truncate" [matTooltip]="data?.full_name | titlecase" [matTooltipClass]="{ 'red-tooltip text-black': true }">{{data?.full_name | titlecase}}</span>

          </p>
          <p class="f-16 icon-color mb-1 f-14 position-relative" *ngIf="data?.job_title">
            <span *ngIf="data?.job_title" class="text-capitalize">{{data?.job_title | titlecase}}</span>
            <span *ngIf="data?.job_title && data?.job_company_name"> at </span>
            <span *ngIf="data?.job_company_name" class="position-relative" >{{data?.job_company_name | titlecase}}</span>


          </p>
          <p class="f-12 mb-1 d-flex align-items-center">
            <i class="far fa-map-marker-alt mr-1 text-9696" *ngIf="data?.location_name"></i>
            <span *ngIf="data?.location_name" class="text-9696 text-capitalize">{{data?.location_name}}</span>
            <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px"
                *ngIf="data?.location_name && data?.totaltenure"></i>
                <span matTooltip="Total years of experience" [matTooltipClass]="{ 'red-tooltip text-black': true }" class="text-9696">
                    <i class="far fa-briefcase mr-1" *ngIf="data?.totaltenure"></i>
                    <span *ngIf="data?.totaltenure" class="text-9696">{{getFormattedTenure(data?.totaltenure)}}</span>
                </span>




            <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px" *ngIf="data?.totaltenure && (data?.linkedin_url || twitter_url || facebook_url)"></i>
            <i class="fas fa-circle text-d9d9d9 mx-2 text-9696" style="font-size:5px" *ngIf="data?.location_name && !data?.totaltenure && (data?.linkedin_url || twitter_url || facebook_url)"></i>

                <a data-testid="auto-app-person-search-similar-slider-a-1" target="_blank" rel="noopener noreferrer" *ngIf="data?.linkedin_url" (click)="openUrl(data?.linkedin_url, 'linkedin')" class="mr-2">
                  <!-- <i class="fab fa-linkedin-in" style="color: #0652ba;"></i> -->
                  <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/fa0r989gg"
                    style="height: 14px; margin-right: 10px;" alt="Linkedin" title="Linkedin"> -->
                    <i class="fa fa-linkedin-square f-16"  aria-hidden="true" style="color: #0652ba;"></i>

                </a>
                <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/fa0r989gg" style="height: 14px; margin-right: 10px;" *ngIf="isBooleanlinkedin_url) &&linkedin_url" alt="Linkedin" title="Linkedin"> -->
                <!-- <i class="fab fa-linkedin text-9696" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(linkedin_url) && linkedin_url" alt="Linkedin" title="Linkedin"></i> -->
                <a data-testid="auto-app-person-search-similar-slider-a-2" target="_blank" rel="noopener noreferrer" *ngIf="twitter_url && !isBoolean(twitter_url)" (click)="openUrl(twitter_url, 'twitter')" class="mr-2">
                  <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/sh2cap19p"
                                              style="height: 14px; margin-right: 10px;" alt="Twitter" title="Twitter"> -->
                  <i class="fa-brands fa-square-x-twitter f-16" style="color: #000000;"></i>
                </a>
                <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/sh2cap19p" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(twitter_url) && twitter_url" alt="Twitter" title="Twitter"> -->
                <i class="fa-brands fa-square-x-twitter text-9696" style="height: 14px; margin-right: 10px;" alt="Twitter" title="Twitter" *ngIf="isBoolean(twitter_url) && twitter_url" alt="Twitter" title="Twitter"></i>
                <a data-testid="auto-app-person-search-similar-slider-a-3" target="_blank" rel="noopener noreferrer" *ngIf="github_url && !isBoolean(github_url)" (click)="openUrl(github_url, 'github')" class="mr-2">
                  <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/i2monblpk" style="height: 14px; margin-right: 10px;" alt="Github" title="Github"> -->
                  <i class="fab fa-github f-16" style="color: black;"></i>
                </a>
                <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/i2monblpk" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(github_url) && github_url" alt="Github" title="Github"> -->
                <!-- <i class="fab fa-github text-9696" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(github_url) && github_url" alt="Github" title="Github"></i> -->
                <a data-testid="auto-app-person-search-similar-slider-a-4" target="_blank" rel="noopener noreferrer" *ngIf="facebook_url && !isBoolean(facebook_url)" (click)="openUrl(facebook_url, 'facebook')" class="mr-2">
                  <i class="fab fa-facebook f-16" style="color: #1773ea;"></i>
                </a>
                <!-- <img src="https://wctest12.s3.us-west-2.amazonaws.com/voakkd5nz"> -->
                <i class="fab fa-facebook-square text-9696" style="height: 14px; margin-right: 10px;" *ngIf="isBoolean(facebook_url) && facebook_url" alt="Facebook" title="Facebook"></i>
        </p>
      </div>
      </div>
      <hr>

    </div>
  </div>
  <div class="h-50 justify-content-center wccard d-flex flex-column align-items-center" *ngIf="candidateDetails?.length == 0 && similartabshow">
    <img src="../../assets/emptystate.png" class="empty-state-img"/>
    <p class="f-18 font-weight-600 mt-6">Results Not Found!</p>
</div>

</div>
